import { Link, useLocation } from 'react-router-dom';
import { useCart } from '@/contexts/CartContext';

const navItems = [
  { label: 'Ana Sayfa', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', path: '/' },
  { label: 'Kategoriler', icon: 'ri-grid-line', activeIcon: 'ri-grid-fill', path: '/urunler' },
  { label: 'Ara', icon: 'ri-search-line', activeIcon: 'ri-search-fill', path: '/urunler?arama=' },
  { label: 'Sepet', icon: 'ri-shopping-bag-line', activeIcon: 'ri-shopping-bag-fill', path: '/sepet' },
  { label: 'Kampanyalar', icon: 'ri-price-tag-3-line', activeIcon: 'ri-price-tag-3-fill', path: '/kampanyalar' },
];

export default function BottomNav() {
  const location = useLocation();
  const { getTotalItems } = useCart();
  const cartCount = getTotalItems();

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path.split('?')[0]);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white border-t border-gray-100" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="flex items-stretch">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex-1 flex flex-col items-center justify-center py-2 gap-0.5 cursor-pointer transition-colors duration-200 relative"
            >
              <div className="relative w-6 h-6 flex items-center justify-center">
                <i
                  className={`text-xl transition-all duration-200 ${active ? item.activeIcon : item.icon} ${active ? 'text-[#2C5F2D]' : 'text-gray-400'}`}
                />
                {item.label === 'Sepet' && cartCount > 0 && (
                  <span className="absolute -top-1.5 -right-2 bg-[#DC143C] text-white text-[9px] font-bold min-w-[16px] h-4 flex items-center justify-center rounded-full px-0.5">
                    {cartCount > 99 ? '99+' : cartCount}
                  </span>
                )}
              </div>
              <span className={`text-[10px] font-semibold transition-colors duration-200 ${active ? 'text-[#2C5F2D]' : 'text-gray-400'}`}>
                {item.label}
              </span>
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#2C5F2D] rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
